/**
 * CF7 Input Wrap
 * ==============================================
 */

;(function ($, window, document, undefined) {
    "use strict";


     function cf_wrap() {
         if($('.widget_aheto__cf--assistrx-classic-form input[type="submit"]').length){
             $('.widget_aheto__cf--assistrx-classic-form input[type="submit"]').each(function () {
                 $(this).wrap('<div class="submit-wrap"></div>')
             })

             $('.widget_aheto__cf--assistrx-classic-form input[type="submit"]').each(function () {

                 let textColor = $(this).css('background-color');

                 $(this).closest('.widget_aheto__cf--assistrx__subscribe-simple').css('color', textColor);

             });
         }

         if($('.widget_aheto__cf--assistrx-classic-form textarea').length){
             $('.widget_aheto__cf--assistrx-classic-form textarea').each(function () {
                 $(this).closest('.wpcf7-form-control-wrap').wrap('<div class="textarea-wrap"></div>')
             })
         }
     }



    cf_wrap();

    if ( window.elementorFrontend ) {
        cf_wrap();
    }


})(jQuery, window, document);


jQuery(document).ready(function($) {
    function handleFormSubmit() {
        const $submitBtn = $('.wpcf7-submit' );


        $submitBtn.on( 'click', function( e) {
            const $form	= $(this).parents('form');

            $form.parent().on('wpcf7mailsent', function () {
                const $response = $(this).find('.wpcf7-response-output');

                setTimeout((function () {
                    if(!$response.find('h4').length)  {
                        $response.prepend( "<h4>Success</h4>" );
                    }
                }), 100);


                $(this).find('p').slideUp('slow');


            })
        } );
    }

    $(window).on('load', function () {
        handleFormSubmit();
    })

});






